export const wait = async (ms: number) => {
  // eslint-disable-next-line no-new
  await new Promise<void>((resolve) => {
    setTimeout(resolve, ms);
  });
};
